import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#f5f3ee] flex items-center justify-center px-6">
      <div className="bg-white rounded-lg border border-[#e3e0d3] p-10 max-w-md w-full text-center" data-testid="payment-cancel-page">
        <XCircle size={40} className="mx-auto text-[#51637a]" />
        <h1 className="text-xl font-bold text-[#0d2f4d] mt-5">Checkout cancelled</h1>
        <p className="text-sm text-[#51637a] mt-2">No charge was made. You can pick a plan whenever you're ready.</p>
        <Link to="/employer/partnership" data-testid="back-to-plans"
          className="inline-flex mt-7 rounded-full bg-[#0d2f4d] text-white text-sm font-medium px-7 py-3 hover:bg-[#1c4d78] transition-colors">
          Back to plans
        </Link>
      </div>
    </div>
  );
}
